/**
 * Utility class for case conversions
 */
export class CasingUtils {
  /**
   * Converts snake_case to camelCase
   */
  static snakeToCamel(str: string): string {
    return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
  }

  /**
   * Recursively converts object keys from snake_case to camelCase
   */
  static convertKeysToCamelCase(obj: any): any {
    if (obj === null || obj === undefined) return obj;

    if (obj instanceof Date) {
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map((item) => this.convertKeysToCamelCase(item));
    }

    if (typeof obj === "object") {
      const converted: Record<string, any> = {};
      for (const [key, value] of Object.entries(obj)) {
        const camelKey = this.snakeToCamel(key);
        converted[camelKey] = this.convertKeysToCamelCase(value);
      }
      return converted;
    }

    return obj;
  }
}
